import { EnumRootEventBus, rootEventBus } from "../managers/RootEventBus";


export default function checkVideoMode() {
  const params = new URLSearchParams(window.location.search);
  const videoMode = params.get("videomode");
  if (videoMode) {
    rootEventBus.emit(EnumRootEventBus.onVideoMode);
  }
}